import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrService } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { RecruitmentOfferService } from '../../../../../core/services/recruitment-offer.service';
import { RecruitmentApplicationService } from '../../../../../core/services/recruitment-application.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
  selector: 'app-recruitment-offer',
  templateUrl: './recruitment-offer.component.html',
  imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
  styleUrls: ['./recruitment-offer.component.css']
})
export class RecruitmentOfferComponent {
  buttonsPermission: any;
  search_text = '';
  data: any[] = [];
  selected_data: any;
  loading = false;

  // candidatures (modal)
  applications: any[] = [];
  applicationsLoading = false;
  currentOffer: any = null;

  form: any = this.emptyForm();

  readonly CONTRACT_TYPES = ['CDI', 'CDD', 'Vacation', 'Stage'];

  pg = { pageSize: 10, p: 0, total: 0 };

  constructor(
    private offerService: RecruitmentOfferService,
    private applicationService: RecruitmentApplicationService,
    private toastrService: ToastrService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.buttonsPermission = { show: true, add: true, edit: true, delete: true, status: true };
    this.getAll();
  }

  emptyForm() {
    return {
      title: '', description: '', profile_required: '', contract_type: 'CDI',
      category: '', location: '', positions: 1, salary_min: null, salary_max: null,
      deadline: '', status: 0
    };
  }

  getAll() {
    this.loading = true;
    this.offerService.getAll().subscribe((res: any) => {
      this.loading = false;
      this.data = res.data ?? [];
      this.pg.total = this.data.length;
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Offres de recrutement', err); });
  }

  store(value: any) {
    this.loading = true;
    this.offerService.store(value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.form = this.emptyForm();
      this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Offres de recrutement', err); });
  }

  update(value: any) {
    this.loading = true;
    this.offerService.update(this.selected_data.id, value).subscribe((res: any) => {
      this.loading = false;
      this.toastrService.success(res.message);
      this.modalService.dismissAll();
      this.getAll();
    }, (err: any) => { this.loading = false; AppErrorShow.showError('Offres de recrutement', err); });
  }

  delete() {
    if (!this.verifyChecked()) return;
    const confirmed = AppSweetAlert.confirmBox('info', 'Suppression', 'Voulez-vous vraiment supprimer cette offre ?');
    confirmed.then((result: any) => {
      if (result.isConfirmed) {
        this.offerService.delete(this.selected_data.id).subscribe((res: any) => {
          this.toastrService.success(res.message);
          this.selected_data = null;
          this.getAll();
        }, (err: any) => AppErrorShow.showError('Offres de recrutement', err));
      }
    });
  }

  setState(state: number) {
    if (!this.verifyChecked()) return;
    this.offerService.setState(this.selected_data.id, state).subscribe((res: any) => {
      this.toastrService.success(res.message);
      this.getAll();
    }, (err: any) => AppErrorShow.showError('Offres de recrutement', err));
  }

  checked(el?: any) { this.selected_data = el; }

  verifyChecked() {
    if (this.selected_data == null) { this.toastrService.warning('Aucune offre sélectionnée'); return false; }
    return true;
  }

  add(content: any) {
    this.form = this.emptyForm();
    this.modalService.open(content, { size: 'lg' });
  }

  edit(content: any) {
    if (!this.verifyChecked()) return;
    this.form = { ...this.selected_data };
    this.modalService.open(content, { size: 'lg' });
  }

  // Candidatures pour une offre (modal)
  showApplications(offer: any, content: any) {
    this.currentOffer = offer;
    this.applications = [];
    this.applicationsLoading = true;
    this.modalService.open(content, { size: 'lg' });
    this.applicationService.getByOffer(offer.id).subscribe((res: any) => {
      this.applicationsLoading = false;
      this.applications = res.data ?? [];
    }, (err: any) => { this.applicationsLoading = false; AppErrorShow.showError('Candidatures', err); });
  }

  dismiss() { this.modalService.dismissAll(); }

  getPage(event: any) { this.pg.p = event; }

  statusLabel(s: number) { return s == 1 ? 'Publiée' : (s == 2 ? 'Clôturée' : 'Brouillon'); }
  statusClass(s: number) { return s == 1 ? 'bg-green-100 text-green-700' : (s == 2 ? 'bg-gray-200 text-gray-600' : 'bg-orange-100 text-orange-700'); }

  appStatusLabel(s: number) {
    return ['Soumise', 'Présélectionnée', 'Entretien', 'Retenue', 'Rejetée'][s] ?? 'Soumise';
  }
  appStatusClass(s: number) {
    return ['bg-blue-100 text-blue-700', 'bg-indigo-100 text-indigo-700', 'bg-amber-100 text-amber-700', 'bg-green-100 text-green-700', 'bg-red-100 text-red-700'][s] ?? 'bg-blue-100 text-blue-700';
  }
}
